import { z } from 'zod';
import { EmailSchema, IsoTimestampSchema, SchemaVersionSchema } from './shared.js';
export const NotificationChannelsSchema = z.object({
    email: z.boolean(),
    teams: z.boolean(),
    inAppBell: z.boolean(),
    webPush: z.boolean(),
});
export const NotificationSubscriptionSchema = z.object({
    id: z.string(),
    type: z.literal('notification_subscription'),
    schemaVersion: SchemaVersionSchema,
    userEmail: EmailSchema,
    eventType: z.string(),
    channels: NotificationChannelsSchema,
    createdAt: IsoTimestampSchema,
    updatedAt: IsoTimestampSchema,
    version: z.number().int().positive(),
});
//# sourceMappingURL=notification-subscription.js.map